"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatorFactory = void 0;
function validatorFactory(name, validator, message) {
    return function (value, propertyName, entity, options) {
        var isValid = validator(value, options, { propertyName: propertyName, entity: entity });
        var customMessage;
        if (options) {
            if (typeof options === "string") {
                customMessage = options;
            }
            else if (options.hasOwnProperty("customMessage")) {
                // @ts-ignore
                customMessage = options.customMessage;
            }
        }
        if (typeof isValid === "boolean") {
            return !isValid ? message(name, { target: entity, propertyName: propertyName, value: value }, customMessage) : undefined;
        }
        else {
            return !isValid.isValid ? message(name, __assign(__assign({}, isValid.errors), { propertyName: propertyName, target: entity, value: value }), customMessage) : undefined;
        }
    };
}
exports.validatorFactory = validatorFactory;
var BaseValidationService = /** @class */ (function () {
    function BaseValidationService() {
    }
    BaseValidationService.prototype.initialize = function (validators) {
        this.validators = validators;
        this.initializeValidators();
    };
    BaseValidationService.prototype.registerValidator = function (name, validator) {
        this.validators.set(name, validatorFactory(name, validator, this.localizedMessage));
    };
    return BaseValidationService;
}());
exports.default = BaseValidationService;
